import { ErrorToast } from "../../shared/index";
import Constants from "../../constants/constants";
function ErrorHandling(error, text, setLoading = null) {
  if (setLoading) setLoading(false);
  if (error.toString().includes(Constants.InternalErrorContain))
    ErrorToast(Constants.serverErrorMsg);
  if (error.toString().includes(Constants.AuthErrorContain))
    ErrorToast(Constants.serverErrorAuth);
  console.log(`--${text}: ${error}`);
}
export default ErrorHandling;
